import { Signal } from '@preact/signals-react';
import { useContext } from 'react';
import { EditorDeclarativeBlock } from '@/webapi/use-experience-api';
import { EditorContext } from '@/features/editor/context/editor-context';

import { AiComponentTab } from '@/features/editor/widgets/shared/ai-editing-layout/types';

export interface ChangePersistenceActions {
  applyChanges: () => void;
  discardChanges: () => void;
  saveLocalChanges: () => void;
  discardLocalChanges: () => void;
}

export function useChangePersistence(
  newChange: Signal<EditorDeclarativeBlock>,
  lastSavedChange: Signal<EditorDeclarativeBlock>,
  selectTab: (tab: AiComponentTab) => void,
): ChangePersistenceActions {
  const {
    inspectorNav: { gotoChangelog },
    experienceState: { upsertEditorChange },
  } = useContext(EditorContext);

  const applyChanges = () => {
    upsertEditorChange(newChange.value);
    gotoChangelog();
  };

  const discardChanges = () => {
    gotoChangelog();
  };

  const saveLocalChanges = () => {
    lastSavedChange.value = newChange.value;
    selectTab(AiComponentTab.PROMPT);
  };

  const discardLocalChanges = () => {
    newChange.value = lastSavedChange.value;
    selectTab(AiComponentTab.PROMPT);
  };

  return {
    applyChanges,
    discardChanges,
    saveLocalChanges,
    discardLocalChanges,
  };
}
